import {UnitConversionConfig} from 'main/content/system/unit-conversion/UnitConversionConfig';
import {UnitTypeConfig} from 'main/content/system/unit-type/unitTypeConfig';
import {UnitCategoryConfig} from 'main/content/system/unit-category/unitCategoryConfig';

export const systemConfigs = [
    UnitConversionConfig,
    UnitTypeConfig,
    UnitCategoryConfig
];


// WEBPACK FOOTER //
// ./src/main/content/system/SystemConfigs.js